import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner';
import { format, parseISO } from 'date-fns';
import { isEmpty } from 'lodash';
import { isNotBlank } from 'utils/stringUtils';
import DefaultPagination from 'components/DefaultPagination';

// TODO: reuse this for NPWP review page
function BusinessesList({
  data: { list, total, page, size },
  isLoading,
  onBusinessItemClicked,
  onPageChange,
}) {
  const renderKybStatus = status => {
    let text;
    let color;
    switch (status) {
      case 'pending':
        text = 'Pending';
        color = 'orange';
        break;
      case 'approved':
        text = 'Approved';
        color = 'green';
        break;
      case 'rejected':
        text = 'Rejected';
        color = 'red';
        break;
      default:
        text = '';
        color = 'initial';
        break;
    }
    return <span style={{ color }}>{text}</span>;
  };

  const renderTableContent = () => {
    if (isLoading) {
      return (
        <Table.Row>
          <Table.Cell colSpan={6}>
            <LoadingSpinner />
          </Table.Cell>
        </Table.Row>
      );
    }
    if (total === 0) {
      return (
        <Table.Row>
          <Table.Cell colSpan={6} style={{ textAlign: 'center' }}>
            No data
          </Table.Cell>
        </Table.Row>
      );
    }

    return list.map(business => (
      <Table.Row
        key={business.id}
        style={{ cursor: 'pointer' }}
        onClick={() => onBusinessItemClicked(business.id)}
      >
        <Table.Cell>
          {isNotBlank(business.name) ? (
            business.name
          ) : (
            <span style={{ color: 'red' }}>{business.owner_name}</span>
          )}
        </Table.Cell>
        <Table.Cell>{business.id}</Table.Cell>
        <Table.Cell>{business.owner_email}</Table.Cell>
        <Table.Cell>{business.outlets_count}</Table.Cell>
        <Table.Cell>
          {business.expired_at
            ? format(parseISO(business.expired_at), 'dd MMM yyyy')
            : ''}
        </Table.Cell>
        <Table.Cell>{renderKybStatus(business.kyb_status)}</Table.Cell>
      </Table.Row>
    ));
  };

  const onPageChangeRaw = (event, { activePage }) => onPageChange(activePage);

  return (
    <Table celled selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Business Name</Table.HeaderCell>
          <Table.HeaderCell>Business ID</Table.HeaderCell>
          <Table.HeaderCell>Registered Merchants Email</Table.HeaderCell>
          <Table.HeaderCell># of Outlets</Table.HeaderCell>
          <Table.HeaderCell>Expiration</Table.HeaderCell>
          <Table.HeaderCell>KYB Status</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{renderTableContent()}</Table.Body>
      {!isLoading && !isEmpty(list) && (
        <DefaultPagination
          totalCount={total}
          activePage={page}
          pageSize={size}
          onPageChange={onPageChangeRaw}
        />
      )}
    </Table>
  );
}

BusinessesList.propTypes = {
  data: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string,
        owner_name: PropTypes.string.isRequired,
        owner_email: PropTypes.string.isRequired,
        outlets_count: PropTypes.number.isRequired,
        expired_at: PropTypes.instanceOf(Date),
        kyb_status: PropTypes.string,
      })
    ),
    page: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onBusinessItemClicked: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default BusinessesList;
